export default "__VITE_ASSET__Kcia$jdY__"